// import { Controller } from "@hotwired/stimulus"
// import bootstrap from "bootstrap"

// export default class extends Controller {
//   connect() {
//     const modalEl = this.element.querySelector(".modal")
//     if (modalEl) {
//       const modal = new bootstrap.Modal(modalEl)
//       modal.show()
//     }
//   }
// }
